module.exports = __webpack_public_path__ + "img/logo-validateiq-white.fc1459de.png";